import { render, staticRenderFns } from "./taskDetails.vue?vue&type=template&id=1d5b1f74&scoped=true"
import script from "./taskDetails.vue?vue&type=script&lang=js"
export * from "./taskDetails.vue?vue&type=script&lang=js"
import style0 from "./taskDetails.vue?vue&type=style&index=0&id=1d5b1f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b1f74",
  null
  
)

export default component.exports